import { MudLoggingCostBase } from './base/mud-logging-cost-base';

export class MudLoggingCost extends MudLoggingCostBase { }